import { ICashierSettingsForm } from 'api/cashierSettings/types';

export enum NAVIGATION_OPTIONS {
  AMOUNTS = 'amounts',
  COMMISSION = 'commission',
  GENERAL = 'general',
  IGNORE = 'ignoreInfo',
  PSP_SETTINGS = 'pspSettings',
}

export const NAVIGATION_LIST = [
  { name: NAVIGATION_OPTIONS.GENERAL },
  { name: NAVIGATION_OPTIONS.COMMISSION },
  { name: NAVIGATION_OPTIONS.AMOUNTS },
  { name: NAVIGATION_OPTIONS.PSP_SETTINGS },
  { name: NAVIGATION_OPTIONS.IGNORE },
];

export const defaultValues: ICashierSettingsForm = {
  amountInputDecimalSeparator: 'DOT',
  amountInputThousandsSeparator: 'NONE',
  amountTextDecimalSeparator: 'DOT',
  amountTextThousandsSeparator: 'NONE',
  commission: 0,
  commissionConfirmation: false,
  currency: null,
  currencySymbolOverride: null,
  defaultAmount: null,
  earlyRouting: false,
  enableCurrencyPositionAfter: true,
  enableCurrencySymbolOverride: false,
  enablePromoCode: false,
  ignoreCardholder: false,
  ignoreCvv: false,
  merchantId: null,
  merchantTerminalId: null,
  minCommission: 0,
  onlyRoundAmount: false,
  paymentMethod: null,
  predefinedAmounts: {
    amount1: null,
    amount2: null,
    amount3: null,
  },
  transactionType: null,
  // requestCardPan: false,
  // requestAccountId: false,
  // accountIdPlaceholder: null,
  // accountIdRegExp: null,
};

export const CURRENCY_POSITION_BINARY_OPTIONS = [
  { label: 'cashierSettings.form.currencyPosition.before', value: 'false' },
  { label: 'cashierSettings.form.currencyPosition.after', value: 'true' },
];
